/**
 * This objects holds allowed properties for Filter class
 * @type {Readonly<{}>}
 */
const FILTER_CLASS_PROPERTIES = Object.freeze({
    SEARCH: 'search',
    _SEARCH: '_search',
    SEARCH_LABEL: 'searchLabel',
    _SEARCH_LABEL: '_searchLabel',
    PRICE: 'price',
    _PRICE: '_price',
    BEDS: 'beds',
    _BEDS: '_beds',
    BATHS: 'baths',
    _BATHS: '_baths',
    HOME_TYPE: 'homeType',
    _HOME_TYPE: '_homeType',
    SALE: 'sale',
    _SALE: '_sale',
    FAVORITE: 'favorite',
    _FAVORITE: '_favorite',
    ORDER_BY: 'orderBy',
    _ORDER_BY: '_orderBy',
    LOCATION: 'location',
    _LOCATION: '_location',
    SQUARE_FEET: 'squareFeet',
    _SQUARE_FEET: '_squareFeet',
    LOT_SIZE: 'lotSize',
    _LOT_SIZE: '_lotSize',
    YEAR_BUILT: 'yearBuilt',
    _YEAR_BUILT: '_yearBuilt',
    KEYWORDS: 'keywords',
    _KEYWORDS: '_keywords',
    IS_SOLD: 'isSold',
    _IS_SOLD: '_isSold',
    INCLUDE_PENDING: 'includePending',
    _INCLUDE_PENDING: '_includePending',
});

/**
 * This objects holds allowed values for _filterOption property of FilterOptions class
 * @type {Readonly<{}>}
 */
export const FILTER_OPTIONS = Object.freeze({
    SEARCH: 'search',
    SEARCH_LABEL: 'searchLabel',
    PRICE: 'price',
    BEDS: 'beds',
    BATHS: 'baths',
    HOME_TYPE: 'homeType',
    SALE: 'sale',
    FAVORITE: 'favorite',
    ORDER_BY: 'orderBy',
    LOCATION: 'location',
    SQUARE_FEET: 'squareFeet',
    LOT_SIZE: 'lotSize',
    YEAR_BUILT: 'yearBuilt',
    KEYWORDS: 'keywords',
    IS_SOLD: 'isSold',
    INCLUDE_PENDING: 'includePending',
});

export function validateFilterOption(filterOption, filterClass = false) {
    let filterOptions;
    filterClass ? filterOptions = FILTER_CLASS_PROPERTIES : filterOptions = FILTER_OPTIONS;

    if(Object.values(filterOptions).indexOf(filterOption) === -1) {
        throw new Error("Filter option can only have " +
            Object.values(filterOptions).toString().split(',').join(', ')
            +" as value. Given value:" + filterOption);
    }
}
